import { Component, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';

import { Listview, ListviewEntry } from '../../model/his-listview.model';
import { HisTranslationService } from '../../../translation/service/his-translation.service';
import { HisNavigationService } from '../../../core/service/base/his-navigation.service';
import { HisBaseGlobalsService } from '../../../core/service/base/his-base-globals.service';

@Component( {
    selector: 'his-listviewentry',
    templateUrl: './his-listviewEntry.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisListviewEntryComponent {
    private hisTranslationService = inject(HisTranslationService);
    private navigationService = inject(HisNavigationService);
    private hisBaseGlobalsService = inject(HisBaseGlobalsService);

    @Input() listview: Listview;
    @Input() customClickHandler: boolean;
    @Output() btnMoreClicked = new EventEmitter<boolean>();

    public getSecondaryDetails( hisObject: any ): string {
        let details = this.getTranslation( 'secondaryDetails', hisObject );
        return ( details.substring( 1, details.length - 1 ) );
    }

    public getTranslation( hisAttribute: string, hisObject: any ): string {
        return this.hisTranslationService.translate( hisObject, hisAttribute );
    }

    public isSameRouterContext( entryViewUrl: string ): boolean {
        let routerContext = this.getExtensionRouterContext( entryViewUrl );
        if ( window.location.href.includes( routerContext ) ) {
            // console.log( 'HisListviewEntryComponent using router link navigation to context:', routerContext );
            return true;
        }
        // console.log( 'HisListviewEntryComponent using href link navigation to context:', routerContext );
        return false;
    }

    public getRouterLinkUrl( entryViewUrl: string ) {
        return entryViewUrl.replace( '../' + this.getExtensionRouterContext( entryViewUrl ), '' );
    }

    public getHrefForMoreEntries(listview: Listview): string {
        let configFile: string ='';
        let paramBackButton ='&showBackButton=true';
        let paramInactiveSearch ='&isNotActiveSearch=true';
        
        if (listview.searchQueryParams.configFileHeadless) {
            configFile = listview.searchQueryParams.configFileHeadless;
        } else {
            configFile = listview.searchQueryParams.configFile;
        }
        
        let url = listview.searchUrl+ 
                '?configFile=' + configFile +
                '&pageTitle=' + listview.searchQueryParams.pageTitle +
                '&tableTitle=' + listview.searchQueryParams.tableTitle +
                '&showChangeSearchButton=' +listview.searchQueryParams.showChangeSearchButton +
                '&' + listview.searchQueryParams.objectIdFilter +
                paramBackButton + paramInactiveSearch ;
        return encodeURI(url);
    }
    
    public moreEntriesClicked( event: Event ) {
        if ( this.customClickHandler ) {
            event.preventDefault();
            this.btnMoreClicked.emit( true );
        } else {
            this.onBeforeNavigate();
        }
    }

    public getQueryParamShowSearchButton( entry: ListviewEntry ) {
        if ( entry.viewQueryParams && typeof entry.viewQueryParams.showSearchButton !== 'undefined' ) {
            return `&showSearchButton=${entry.viewQueryParams.showSearchButton}`;
        } else {
            return '';
        }
    }

    private getExtensionRouterContext( url: string ) {
        let firstIndexSlash = url.indexOf( '/' ) + 1;
        let secondIndexSlash = url.indexOf( '/', url.indexOf( '/' ) + 1 );
        return url.substring( firstIndexSlash, secondIndexSlash );
    }

    /* leaving page action use onBeforeNavigate set last back url with navigationService */
    public onBeforeNavigate() {
        this.navigationService.setLastBackUrl();
    }
}
